(function () {
  'use strict';
  window.APP = window.APP || {
    Routers: {},
    Collections: {},
    Models: {},
    Views: {},
  };
  APP.routerViews = {};

  APP.goto = function (name, options) {
    var currentPath = window.location.pathname;
    var state = {
      room_name: (window.fixtures && fixtures.room_name) || null,
      room_ais: (window.fixtures && fixtures.room_ais) || {},
      currentAI: (window.fixtures && fixtures.currentAI) || null,
    };

    // Normalize route to fragment form (no leading slash)
    var route = name == null ? '' : String(name);
    if (route.charAt(0) === '/') {
      route = route.slice(1);
    }

    window.history.replaceState(state, '', currentPath);

    APP.router.navigate(route, { trigger: true });
    return false;
  };

  APP.stepBack = function () {
    var currrentPath = window.location.hash;
    if (currrentPath == '') {
      currrentPath = window.location.pathname;
    }
    if (currrentPath.length <= 1) {
      APP.goto('/');
    } else {
      currrentPath = currrentPath.split('/');
      currrentPath.pop();
      currrentPath = currrentPath.join('/');
      APP.goto(currrentPath);
    }
    return false;
  };

  $(document).on('click', 'a:not([data-bypass])', function (e) {
    var href = $(this).prop('href');
    if (!href) {
      return true;
    }

    var root = location.protocol + '//' + location.host + '/';

    // Respect modifier keys/middle click/blank targets/downloads
    if (
      e.defaultPrevented ||
      e.which === 2 ||
      e.button === 1 ||
      e.metaKey ||
      e.ctrlKey ||
      e.shiftKey ||
      e.altKey
    ) {
      return true;
    }
    var targetAttr = this.getAttribute('target');
    if (targetAttr && targetAttr.toLowerCase() === '_blank') {
      return true;
    }
    if (this.hasAttribute('download')) {
      return true;
    }

    // Only intercept internal links
    if (href.slice(0, root.length) !== root) {
      return true;
    }

    // Parse and normalize path without leading slash
    var parsed;
    try {
      parsed = new URL(href, root);
    } catch (err) {
      return true;
    }
    var pathNoSlash = parsed.pathname.replace(/^\//, '');

    // Only intercept known SPA routes (rooms and ai-chat)
    var isSpaRoute = /^(?:r\/.+|ai-chat(?:\/|$))/.test(pathNoSlash);
    if (!isSpaRoute) {
      return true;
    }

    // If router not ready, allow default navigation
    var routerReady = !!(
      window.viewsLoaded &&
      window.APP &&
      APP.router &&
      window.Backbone &&
      ((Backbone.History && Backbone.History.started === true) ||
        (Backbone.history &&
          (Backbone.history.started === true ||
            (Backbone.history.handlers &&
              Backbone.history.handlers.length > 0))))
    );
    if (!routerReady) {
      return true;
    }

    e.preventDefault();
    APP.goto(pathNoSlash + (parsed.search || ''));
  });

  APP.gotoLink = function (link) {
    var href = $(link).prop('href');
    if (!href) {
      return;
    }
    var root = location.protocol + '//' + location.host + '/';
    if (href.slice(0, root.length) !== root) {
      return;
    }

    var parsed;
    try {
      parsed = new URL(href, root);
    } catch (err) {
      return;
    }
    var pathNoSlash = parsed.pathname.replace(/^\//, '');
    var isSpaRoute = /^(?:r\/.+|ai-chat(?:\/|$))/.test(pathNoSlash);
    var routerReady = !!(
      window.viewsLoaded &&
      window.APP &&
      APP.router &&
      window.Backbone &&
      ((Backbone.History && Backbone.History.started === true) ||
        (Backbone.history &&
          (Backbone.history.started === true ||
            (Backbone.history.handlers &&
              Backbone.history.handlers.length > 0))))
    );
    if (isSpaRoute && routerReady) {
      APP.goto(pathNoSlash + (parsed.search || ''));
      return false;
    }
  };

  var currentView;

  function animateTo(view) {
    var $mainbody = $('#mainbody');
    var duration = 300;
    view.render();

    $('html, body').scrollTop(0);
  }

  APP.refresh = function () {};

  APP.currentView = location.pathname;
  function defaultHandler(pathname) {
    return function () {
      var args = arguments;
      if (APP.currentView == pathname && prerenderedPages[APP.currentView]) {
        return;
      }

      APP.currentView = pathname;
      APP.refresh();

      try {
        var ViewCtor = APP.Views[pathname];
        // Check for dynamic route pattern if exact match not found
        if (!ViewCtor && pathname.startsWith('/ai-chat/')) {
          ViewCtor = APP.Views['/ai-chat/:name'] || APP.Views['/ai-chat'];
        }
        if (typeof ViewCtor === 'function') {
          animateTo(new ViewCtor({ args: args }));
        } else {
          // Avoid hard navigation on homepage to prevent reload loops
          if (pathname === '/' || pathname === '/r') {
            return;
          }

          // Removed auto-switch for /ai-chat to avoid forced redirect
          if (
            pathname.indexOf('/r') === 0 &&
            window.ChatStateManager &&
            fixtures.room_name
          ) {
            window.ChatStateManager.switchToChatroom({
              room_name: fixtures.room_name,
              room_ais: fixtures.room_ais || {},
            });
            return;
          }

          // As last resort, hard navigate
          window.location.href = pathname;
        }
      } catch (e) {
        console.error('[ROUTER] Failed to render view for', pathname, e);
      }
    };
  }

  var prerenderedPages = {};
  var routes = {};
  $.each(prerenderedPages, function (key, value) {
    routes[key.substring(1)] = value;
  });
  jQuery.extend(routes, {
    '': 'home',
    'ai-chat': 'aichat',
    'ai-chat/:name': 'aichat',
    r: 'r',
    'r/:name': 'r',
  });

  var Router = Backbone.Router.extend({
    routes: routes,
    home: defaultHandler('/'),
    aichat: function (name) {
      // Render landing or character chat without hard redirect
      var pathname = '/ai-chat' + (name ? '/' + name : '');
      if (APP.currentView === pathname && prerenderedPages[APP.currentView]) {
        return;
      }
      APP.currentView = pathname;
      APP.refresh();

      try {
        var ViewCtor = APP.Views['/ai-chat'];
        if (typeof ViewCtor === 'function') {
          // If character specified and ChatStateManager exists, switch context
          if (
            name &&
            window.ChatStateManager &&
            typeof window.ChatStateManager.switchToAIChat === 'function'
          ) {
            fetch('/api/get-ai-by-name?name=' + encodeURIComponent(name))
              .then(function (r) {
                return r.ok ? r.json() : null;
              })
              .then(function (payload) {
                var ai = payload && payload.success ? payload.data : payload;
                if (ai && ai.name) {
                  window.ChatStateManager.switchToAIChat(ai);
                }
              })
              .catch(function () {});
          }
          animateTo(new ViewCtor({ args: arguments }));
        } else {
          // Do not redirect; leave page in place
        }
      } catch (e) {
        console.error('[ROUTER] Failed to render view for', pathname, e);
      }
    },
    r: defaultHandler('/r'),
  });

  $(document).ready(function () {
    // Ensure data-accessor is initialized before routing
    if (typeof window.dataAccessor === 'undefined') {
      try {
        require?.('/static/js/data-accessor.js');
      } catch { /* Error ignored */ }
    }
    APP.router = new Router();

    // Wait for views to be loaded before starting router
    function startRouter() {
      if (window.viewsLoaded) {
        APP.doneLevel = defaultHandler('/done-level');
        Backbone.history.start({
          pushState: true,
        });
      } else {
        setTimeout(startRouter, 100);
      }
    }
    startRouter();

    // Register popstate handler with coordinator if available
    var routerPopstateHandler = function (event) {
      // NavigationManager handles popstate for AI chat routes
      // Let it process first if available and relevant
      const currentPath = window.location.pathname;
      const isAIChatRoute =
        currentPath.startsWith('/ai-chat/') || currentPath.startsWith('/r/');

      if (isAIChatRoute && window.NavigationManager) {
        // NavigationManager will handle this via its own popstate listener
        return;
      }

      var hasCSM = !!window.ChatStateManager;
      if (
        event.state &&
        hasCSM &&
        typeof window.ChatStateManager.restoreState === 'function'
      ) {
        window.ChatStateManager.restoreState(event.state);
        return;
      }

      if (
        hasCSM &&
        currentPath.startsWith('/r/') &&
        fixtures.room_name &&
        typeof window.ChatStateManager.switchToChatroom === 'function'
      ) {
        window.ChatStateManager.switchToChatroom({
          room_name: fixtures.room_name,
          room_ais: fixtures.room_ais || {},
        });
        return;
      }
      if (
        hasCSM &&
        currentPath.startsWith('/ai-chat/') &&
        fixtures.currentAI &&
        typeof window.ChatStateManager.switchToAIChat === 'function'
      ) {
        window.ChatStateManager.switchToAIChat(fixtures.currentAI);
        return;
      }
    };

    if (window.PopStateCoordinator) {
      window.PopStateCoordinator.register(
        routerPopstateHandler,
        25, // Lower priority - runs after navigation and chat handlers
        'Router'
      );
    } else {
      window.addEventListener('popstate', routerPopstateHandler);
    }

    $(document).on('click', '.ws-help-btn', function () {
      var $modal = $('#modal');
      $modal.find('.modal-body').html($('#instructions').html());
      $modal.modal('show');
    });
  });
})();
